import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { BsArrowsAngleContract } from "react-icons/bs";

import LinkContainer from "./Link";
import NestedLink from "./NestedLink";

import { APP_VERSION, LANGUAGE_OPTIONS } from "../../constants";
import useApi from '../../hooks/useApi';
import { network_tl } from '../../translations';
import { customStringify, error_alert, removeToken, setAppLanguage, success_alert } from '../../utils';

import { logout } from '../../redux/slices/userSlice';
import { set_sidebar } from "../../redux/slices/uiSlice";

import { GoSignOut } from "react-icons/go";
import { BiLoaderAlt } from 'react-icons/bi';
import { GoSidebarCollapse } from "react-icons/go";
import { set_language } from '../../redux/slices/languageSlice';
import LanguageSelect from '../Filter/LanguageSelect';

import { FiMinusCircle } from "react-icons/fi";
import { AnimatePresence, motion } from 'framer-motion';
import { RiMenu5Fill } from 'react-icons/ri';
import { HiOutlineLogout } from "react-icons/hi";


const Sidebar = ({ links }) => {
    const intl = useIntl();
    const { Axios } = useApi();
    const dispatch = useDispatch();

    const { sidebar } = useSelector(state => state.ui);
    const lang = useSelector(state => state.language);

    const [language, setLanguage] = useState(lang);

    const handleLanguageChange = (value) => {
        setLanguage(value)
        dispatch(set_language(value))
        setAppLanguage(value.value)
    };

    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        try {
            // setLoading(true);
            // const result = await Axios.get("api/user/logout");
            dispatch(logout());
            removeToken();
            // success_alert(result.data.description);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            }
            else if (e.response) {
                error_alert(customStringify(e.response.data.description));
            } else {
                error_alert(network_tl(intl));
            }
        }
    }


    return (
        <>
            {
                sidebar &&
                <div onClick={() => dispatch(set_sidebar(false))} className="block lg:hidden z-[109] fixed top-0 bottom-0 left-0 right-0 bg-gradient-to-t from-primary primary/70 primary/50">

                </div>
            }
            <div

                className={`w-[230px] flex flex-col bg-white   items-center pb-0 transition-all  shadow-xl rounded-r-2xl fixed top-0 bottom-0 z-[1000] border-base ${sidebar ? "translate-x-0" : "translate-x-[-100%]"}`}>
                {/* // className={`w-[230px] flex flex-col rounded-tr-[50px] rounded-br-[50px] items-center pb-0 transition-all bg-content-bg fixed top-0 bottom-0 z-[1000] border-base ${sidebar ? "translate-x-0" : "translate-x-[-100%]"}`}> */}

                {/* header */}
                <div className='h-[90px] border-b-[1px]  w-full flex flex-col justify-end flex-shrink-0 relative'>
                    <div className='w-[85%] flex-grow mb-[-1px] mx-auto flex items-center justify-between '>
                        <Link to={'/'} className='focus:outline-none'>
                            <img
                                key={"main-logo"}
                                initial={{
                                    y: "50%",
                                    opacity: 0
                                }}
                                animate={{
                                    y: "-50%",
                                    opacity: 1
                                }}
                                exit={{
                                    y: "-50%",
                                    opacity: 0
                                }}
                                src="/images/influencee.png" alt="" className='w-[90px] ' />
                        </Link>
                        {/* <button
                            onClick={() => {
                                dispatch(set_sidebar(false))
                            }}
                            type={"button"}
                            className='group h-[40px] w-[40px] rounded-full hover:bg-primary flex items-center justify-center'
                        >
               

                            <RiMenu5Fill className='text-t-light text-xl rotate-[180deg] group-hover:text-white' />
                        </button> */}
                    </div>
                            
                </div>
                {/* header */}

                {/* content */}
                <div className="w-full py-5 flex-grow space-y-1 overflow-y-auto">
                    <div className='h-full overflow-auto w-[85%] mx-auto'>
                        {
                            links.map((item, index) => (
                                item.links ?
                                    <NestedLink key={index} title={item.title} Icon={item.Icon} to={item.to} links={item.links} />
                                :
                                <div>
                                    {item.heading && <p className='text-sm font-medium text-primary/80 mt-4 mb-2'>{item.heading}</p>}
                                    <LinkContainer key={index} title={item.title} Icon={item.Icon} to={item.to} />
                                </div>
                                

                            ))
                        }
                    </div>


                </div>
                {/* content */}

                {/* footer */}
                <div className='flex-shrink-0 w-[85%] my-8'>
                    <button
                        onClick={handleLogout}
                        type="button"
                        className={`w-full transition-all mb-2 rounded-full hover:bg-primary group flex space-x-3 py-3 px-4 items-center justify-start`}
                    >
                        <HiOutlineLogout className={`transition-all -rotate-180 flex-shrink-0 group-hover:text-white text-xl`} />
                        <span className={`transition-all text-sm font-medium group-hover:text-white `}>
                            <FormattedMessage id="logout" defaultMessage={"Logout"} />
                        </span>
                    </button>
                </div>
                {/* footer */}
            </div>


        </>
    )
}

export default Sidebar